<template>
  <b-section-loader :loading="$loading.isLoading('getContractor')">
    <div>
      <ContractorHeader />
      <ContractorTabs />

      <v-window v-model="activeTab">
        <v-window-item value="general">
          <ContractorGeneralTab />
        </v-window-item>

        <v-window-item value="addresses">
          <ContractorAddressesTab />
        </v-window-item>

        <v-window-item value="contacts">
          <ContractorContactsTab />
        </v-window-item>

        <v-window-item value="links">
          <ContractorLinksTab />
        </v-window-item>

        <v-window-item value="history">
          <ContractorHistoryTab />
        </v-window-item>
      </v-window>
    </div>
  </b-section-loader>
</template>

<script lang="ts">
import { BSectionLoader } from 'best-modules/components'
import { initContractorStore } from '@/pages/contractor/single/contractor'
import ContractorHeader from '@/pages/contractor/single/components/ContractorHeader.vue'
import ContractorTabs from '@/pages/contractor/single/components/ContractorTabs.vue'
import ContractorGeneralTab from '@/pages/contractor/single/tabs/General.vue'
import ContractorAddressesTab from '@/pages/contractor/single/tabs/Addresses.vue'
import ContractorContactsTab from '@/pages/contractor/single/tabs/Contacts.vue'
import ContractorLinksTab from '@/pages/contractor/single/tabs/Links.vue'
import ContractorHistoryTab from '@/pages/contractor/single/tabs/History.vue'

export default {
  name: 'ContractorSingle',
  components: {
    BSectionLoader,
    ContractorAddressesTab,
    ContractorContactsTab,
    ContractorGeneralTab,
    ContractorHeader,
    ContractorHistoryTab,
    ContractorLinksTab,
    ContractorTabs,
  },
  setup() {
    return initContractorStore()
  },
}
</script>
